import authServices from './auth'

const services = {
    ...authServices,
};

export default services;